<div class="max-w-7xl mx-auto px-6 relative group/slider py-12">
  <div class="text-center mb-10">
    <h2 class="text-2xl md:text-3xl font-bold text-[#002670] inline-block relative pb-4">
      মেন্টরই<span class="text-orange-500">আরপি</span> সফটওয়্যার ব্যবহারকারী প্রতিষ্ঠান সমূহ
      <span class="absolute bottom-0 left-0 w-full h-1 bg-orange-400 rounded-full"></span>
    </h2>
  </div>
  <!-- if(isBrowser()){ -->
   @defer (on immediate) {
     <swiper-container #swiperRef slides-per-view="3" space-between="20" loop="true" autoplay-delay="2500"
       autoplay-disable-on-interaction="false" breakpoints='{
           "640": { "slidesPerView": 4 },
           "1024": { "slidesPerView": 6 },
           "1440": { "slidesPerView": 8 }
         }' class="flex items-center pb-4 pt-4">
       @for (slide of slides; track slide.image) {
       <swiper-slide>
         <div class="flex items-center justify-center p-2">
           <div
             class="w-24 h-24 md:w-32 md:h-32 rounded-full border-2 border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 p-2 bg-white overflow-hidden flex items-center justify-center">
             <img [src]="slide.image" [alt]="slide.title" class="w-full h-full object-contain">

           </div>

         </div>
       </swiper-slide>
       }
     </swiper-container>

     <button (click)="goPrev()"
       class="absolute left-0 top-[60%] -translate-y-1/2 z-20 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-[#002670] hover:text-white transition-all hidden md:flex cursor-pointer">
       <i class="fa-solid fa-chevron-left text-sm"></i>
     </button>

     <button (click)="goNext()"
       class="absolute right-0 top-[60%] -translate-y-1/2 z-20 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-[#002670] hover:text-white transition-all hidden md:flex cursor-pointer">
       <i class="fa-solid fa-chevron-right text-sm"></i>
     </button>
   }
  <!-- } -->

</div>